import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'
import Logger from 'core/utils/Logger'

import { IApplyKeyInitiativeOptions } from '../models'

export const applyKeyInitiativeChanges = async <T>({
  ownerId,
  partnerId,
  programType,
  fYear,
  action,
  justification,
  data,
}: IApplyKeyInitiativeOptions<T>): Promise<T[] | null> => {
  const url = proxy('/webservice/621/sp/v3/spJBPKeyInitiativeApplyChanges/call')
  const [accessToken] = getTokens(ownerId)
  const headers = new HttpHeaders()

  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }

  const payload = {
    'p.PartnerId': partnerId,
    'p.ProgramType': programType,
    'p.FYear': fYear,
    'p.Action': action,
    'p.Justification': justification ?? undefined,
    'p.Data': JSON.stringify(data),
  }

  try {
    const response = (await Rest.post({ url, payload, headers })) as { Rows: T[] }
    return response.Rows
  } catch (e: any) {
    Logger.error('Error on apply Key Initiative changes', e)
    return null
  }
}
